import type { IntUser, IntUserResponse } from 'services/local/types';
import type { GmailSignInData, HTTPFunctions, SignIn, SignUpData, ResponseWithData, BasicSuccessResponse } from '../types';
import type { NewAccount } from 'pages/AccountSettings/types';

const getResponseData = <T>(response: ResponseWithData<T>): T => response.data;

const authUser = ({ wrapper, instance, get, put, postGmail, del }: HTTPFunctions) => ({
  signUp: async (data: SignUpData) => wrapper(instance.post<IntUserResponse>("/users/open", data)),
  logout: () => localStorage.removeItem("user"),
  signIn: async (data: SignIn) => {
    const params = new URLSearchParams();
    params.append("username", data.email);
    params.append("password", data.password);
    if (data.reportId) {
      params.append("client_id", data.reportId);
    }
    return wrapper(instance.post<IntUserResponse>("/login/access-token", params));
  },
  gmailSignIn: async (data: GmailSignInData) => postGmail("/swap_token", data),
  passwordRecovery: async (username: string) =>
    wrapper(instance.post<ResponseWithData<IntUserResponse>>(`/password-recovery/${username}`, {}).then(getResponseData)),
  resetPassword: async (new_password: string, token: string) =>
    wrapper(instance.post<ResponseWithData<BasicSuccessResponse>>("/reset-password/", { new_password, token }).then(getResponseData)),
  newPassword: async (old_password: string, new_password: string) =>
    put<ResponseWithData<BasicSuccessResponse>>( '/users/password', {old_password, new_password}).then(getResponseData),
  validateEmail: async (token: string) => wrapper(instance.get<IntUserResponse>(`/users/email_confirmation/${token}`)),
  getAccountSettings: async () => get<IntUser>('/users/me'),
  setAccountSettings: async (data: NewAccount) => put<IntUser>('/users/me', data),
  deleteAccountSettings: async () => del<BasicSuccessResponse>('/users/me'),
});

export default authUser;
